import React, { useId, useState } from 'react';


const Spoiler = (props: {
  children: React.ReactNode;
  big?: boolean;
  showLabel?: string;
  hideLabel?: string;
}) => {

  const [show, setShow] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);
  const contentId = useId();

  if (props.big) {
    return (
      <div className="w-100">
        <button type="button" className="btn btn-warning"
          aria-expanded={show} aria-controls={contentId}
          onClick={() => {
            setShow(value => !value);
            setHasOpened(true);
          }}>
          <i className={`fa ${show ? 'fa-eye-slash' : 'fa-eye'} mr-1`} aria-hidden="true" />
          {show ? (props.hideLabel ?? 'Nascondi spoiler') : (props.showLabel ?? 'Mostra spoiler')}
        </button>
        <div id={contentId} hidden={!show} className="mt-3">
          {hasOpened && props.children}
        </div>
      </div>
    );
  }

  const spoilerShow = () => {
    return (
      <React.Fragment>
        <div>
          <p className="text-warning mb-0">
            <small>Chiudi Spoiler</small>
          </p>
          <span className='border border-warning px-1 py-1' style={{ display: 'inline-block' }}>
            {props.children}
          </span>
        </div>
      </React.Fragment>
    );
  }


  const inside = show ?
    spoilerShow() :
    <span className="badge badge-warning">Spoiler</span>;

  const onClick = () => setShow(val => !val);

  return (
    <span onClick={onClick}>{inside}</span>
  );

}
export default Spoiler;
